/** Compact currency label for Y-axis ticks (e.g. 1500000 → "$1.5M"). */
export function formatDealSizeAxisTick(v: number): string {
	if (v >= 1_000_000_000) {
		const n = v / 1_000_000_000;
		return `$${n % 1 === 0 ? n : n.toFixed(1)}B`;
	}
	if (v >= 1_000_000) {
		const n = v / 1_000_000;
		return `$${n % 1 === 0 ? n : n.toFixed(1)}M`;
	}
	if (v >= 1_000) {
		const n = v / 1_000;
		return `$${n % 1 === 0 ? n : n.toFixed(1)}k`;
	}
	return `$${v}`;
}

/**
 * Formats API-supplied range strings like "$60000000-$80000000" or "$100000000+"
 * into compact labels like "$60M-$80M" or "$100M+".
 */
export function formatDealSizeRangeLabel(label: string): string {
	const plusMatch = label.match(/^\$(\d+)\+$/);
	if (plusMatch) {
		return `${formatDealSizeAxisTick(Number(plusMatch[1]))}+`;
	}
	const rangeMatch = label.match(/^\$(\d+)-\$(\d+)$/);
	if (rangeMatch) {
		return `${formatDealSizeAxisTick(Number(rangeMatch[1]))}-${formatDealSizeAxisTick(Number(rangeMatch[2]))}`;
	}
	return label;
}
